import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Audience Network banner: a 324x54 strip with the page's logo, the headline
 * and domain, and the call to action as a blue block. It carries no image.
 */
@Component({
  selector: 'app-meta-audience-network-banner',
  imports: [CommonModule],
  templateUrl: './audience-network-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/audience-network/audience-network-styles.scss',
    './audience-network-banner.component.scss',
  ]
})
export class MetaAudienceNetworkBannerPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly avatar = MetaPreviewCopy.AVATAR;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
